export default "__VITE_ASSET__BJ5j_bAF__"